import debounce from 'debounce';
import select from 'dom-select';

export const AccordionTabs = (el) => {
  const ui = {
    el,
    body: select('body', document),
    details: select.all('.details:not(.details--transcript)', el),
    firstDetail: select('.details:first-of-type', el),
    expand: select('.accordion-tabs__expand', el),
    collapse: select('.accordion-tabs__collapse', el),
    wrapper: select('.wrapper', el),
    accordionTabs: select.all('.accordion-tabs', document),
    nextButtons: select.all('.accordion-tabs__next', el),
    iframes: select.all('iframe', el),
    videos: select.all('video', el),
    youtubes: select.all('lite-youtube', el),
  };

  const threshold = 1024;

  const giveAccordionTabsAnId = () => {
    ui.accordionTabs.forEach((el, index) => {
      if (!el.id) {
        el.setAttribute('id', `accordion-tabs-${index + 1}`);
      }
    });
  }

  // The `name` attribute enables multiple <details> elements to be connected, with only one open at a time, if they have the same name. This is useful for 'tab' behavior.
  const addDetailNames = () => {
    const name = ui.el.id + 'tab';

    ui.details.forEach(detail => {
      detail.setAttribute('name', name);
    });
  }

  const removeDetailNames = () => {
    ui.details.forEach(detail => {
      detail.removeAttribute('name');
    });
  }

  const openAll = () => {
    ui.details.forEach(detail => {
      detail.setAttribute('open', 'open');
    });
  }

  const closeAll = () => {
    ui.details.forEach(detail => {
      detail.removeAttribute('open');
    });
  }

  const openFirst = () => {
    ui.firstDetail.setAttribute('open', 'open');
  }

  const addNamesToDetails = () => {
    let windowWidth = window.innerWidth;

    // Executed only if "data-tabs='true'" on the container and on > 1024 
    if ((el.dataset.tabs === 'true') && (windowWidth > threshold)) {
      addDetailNames();

      const openDetails = select.all('.details[open]:not(.details--transcript)', el);

      if (openDetails.length < '1' || openDetails.length > '1') {
        closeAll();
        openFirst();
      }

    } else {
      removeDetailNames();
    }
  }
  
  const pauseVideos = () => {
    if (ui.videos) {
      ui.videos.forEach(video => {
        video.pause();
      });
    }

    if (ui.youtubes) {
      let activeVideo = select('lite-youtube.lyt-activated');
      
      if (activeVideo) {
        var getYouTubeAPI = async function () { // async to await promise
          const player = await activeVideo.getYTPlayer();
          if (player.getPlayerState = 1) { // eslint-disable-line no-cond-assign
            player.pauseVideo();
          }
        }
        getYouTubeAPI();
      }
    }

    if (ui.iframes) {
      ui.iframes.forEach(iframe => {
        let iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      });
    }
  }

  const setHeights = () => {
    const windowWidth = window.innerWidth;
    // Only proceed if tabs are enabled and window is wide enough
    if (ui.el.dataset.tabs && (windowWidth > threshold)) {
      const openDetail = ui.details.find(detail => detail.open);
      if (openDetail) {
        const summary = select('.accordion-tabs__items', el);
        const content = select('.details__content', openDetail);
        const summaryHeight = summary.getBoundingClientRect().height;
        const contentHeight = content.getBoundingClientRect().height;

        if (summary && content) {
          if (el.classList.contains('accordion-tabs--alt')) {
            if (summaryHeight > contentHeight) {
              ui.wrapper.style.height = summaryHeight + 'px';
            } else {
              ui.wrapper.style.height = contentHeight + 'px';
            }
          } else {
            ui.wrapper.style.height = summaryHeight + contentHeight + 'px';
          };
        }
      }
    } else if (ui.wrapper) {
      ui.wrapper.style.height = 'auto';
    }
  }

  const lookForHash = () => {
    if (window.location.hash) {
      // if window.location has a hash, look for this corresponding id within this accordionTabs
      let hashTarget = select(window.location.hash, el);
      
      // if the target is found, close all all details, and then open the target's parent
      if (hashTarget) {
        let hashTargetParent = hashTarget.closest('.details');
        closeAll();
        hashTargetParent.setAttribute('open', 'open');
      }
    }
  }

  const handleNextButtons = () => {
    ui.nextButtons.forEach(nextButton => {
      const targetID = nextButton.getAttribute('href');
      const targetEl = select(targetID, el);
      const summary = select('.summary', targetEl);

      nextButton.addEventListener('click', (e) => {
        e.preventDefault();

        if (summary) {
          targetEl.setAttribute("open", "open");
          summary.click();
        }
      });
    });
  }

  const handleResize = () => {
    addNamesToDetails();
    setHeights();
  }

  const addEvents = () => {
    giveAccordionTabsAnId();
    lookForHash();
    addNamesToDetails();
    handleNextButtons();

    window.addEventListener('resize', () => {
      debounce(handleResize, 20);
    });

    if (ui.details) {
      ui.details.forEach(detail => {
        detail.addEventListener('toggle', () => {
          setHeights();
          pauseVideos();
        })
      });
    }

    if (ui.expand) {
      ui.expand.addEventListener('click', () => {
        openAll();
      });
    }

    if (ui.collapse) {
      ui.collapse.addEventListener('click', () => {
        closeAll();
      });
    }

    if (ui.nextButtons) {
      ui.nextButtons.forEach(nextButton => {
        const targetID = nextButton.getAttribute('href');
        const targetEl = select(targetID, el);
        
        nextButton.addEventListener('click', () => {
          const summary = select('summary', targetEl);
          if (summary) {
            summary.click();
          }
        });
      });
    }
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default AccordionTabs;
